import { Component, OnInit } from '@angular/core';
import { FilteredListConfig, FilteredListItem, Badge } from '@appcatalyst/ng-cms-core-lib';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-regions',
  templateUrl: './regions.component.html',
  styleUrls: ['./regions.component.scss'],
  providers: [FilteredListConfig]
})
export class RegionsComponent implements OnInit {
  regions$: Observable<any>
  private regions: any[]
  params: any
  
  constructor(
    private config: FilteredListConfig,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.params = {...params}
    })
    this.route.data.subscribe((data: {regions: any}) => {
      this.regions$ = data.regions
      this.regions = data.regions.data
      this.config.listItems = this.regions.map(region => {
        return {
          _id: null,
          title: region,
        }
      });
      this.config.count = data.regions.count
      this.config.page = data.regions.page
      this.config.limit = data.regions.limit
      this.config.emitChanges()
    })
    this.config.title = 'Regions'
  }
}
